import { isAgentDirectoryPath } from "@/helpers/agentDirectory";
import React, { useState } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import BaseHeader from "@/components/Common/BaseHeader";
import Introductions from "@/components/HeaderButtons/Introductions";
import { useUserDetails } from "@/context";
import { pageURLs } from "@/constants";
import Home from "@/images/v2/Home-icon.svg";
import Inventory from "@/images/v2/Inventory.svg";
import { BaseSidebarWrapper, HeaderSidebarBaseWrapper, SidebarItem } from "./HeaderSidebar";
import MobileAppNav from "@/components/MobileTabBar/MobileAppNav";
import { consumerTabs } from "@/components/MobileTabBar/navItems";

const Sidebar = ({ currentURL, handleGoInventory, handleGoFeed, shouldToggleColor }) => {

  return (
    <BaseSidebarWrapper shouldToggleColor={shouldToggleColor}>
      <SidebarItem
        label="Feed"
        icon={Home}
        onClick={handleGoFeed}
        isActive={currentURL === "/" || currentURL === pageURLs.home}
      />

      <SidebarItem
        icon={Inventory}
        label={"My Inventory"}
        isActive={currentURL === pageURLs.consumerInventoryListing}
        onClick={handleGoInventory}
      />
    </BaseSidebarWrapper>
  );
};

const HeaderSidebarConsumer = React.forwardRef((allProps, headerRef) => {

  const {
    headerHeight,
    handleAgentOnboardingModal,
    handleGoFeed,
    user,
    currentURL,
    userPlan,
    showAgentMenuNotificationIcon,
    handleGoInventory,
    goTo,
    handleLogOut,
    introductionList,
    isLoadIntroList,
    unreadMessageCount,
    unreadChatCount,
    dmMessageCount,
    introCountKnown,
    chatCountKnown,
    dmCountKnown,
    handleHandShakeClick,
    updateIntroStateonHover,
    updateIntroPageOnScroll,
    handleCloseIntroList,
    isGitchaDefaultWebsite,
  } = allProps;

  const [showBasicPlanModal, setBasicPlanModal] = useState(false);
  const [contactModalState, setContactModalState] = useState(false);

  const BasicPlanModalShow = () => setBasicPlanModal(true);
  const ContactModalShow = () => setContactModalState(true);

  const navigate = useNavigate();

  const userDetails = useUserDetails();

  const headerContent = HeaderSidebarBaseWrapper({
    ...allProps,
    sidebar: <Sidebar
      currentURL={currentURL}
      handleGoInventory={handleGoInventory}
      handleGoFeed={handleGoFeed}
      shouldToggleColor={userDetails?.shouldToggleColor}
    />,
    mobileNav: _.get(user, "userInfo", null) ? (
      <MobileAppNav
        tone={isGitchaDefaultWebsite ? "gitcha" : "tenant"}
        items={consumerTabs({
          signedIn: true,
          isGitchaDefaultWebsite,
          actions: {
            feed: handleGoFeed,
            myHome: handleGoInventory,
            agents: () => navigate(pageURLs.agentDirectory),
          },
          active: {
            feed: currentURL === "/" || currentURL === pageURLs.home,
            myHome: currentURL === pageURLs.consumerInventoryListing,
            agents: isAgentDirectoryPath(currentURL),
          },
        })}
        inbox={{
          unreadIntroductions: unreadMessageCount || 0,
          unreadMessages: (unreadChatCount || 0) + (dmMessageCount || 0),
          countsKnown: Boolean(introCountKnown && chatCountKnown && dmCountKnown),
          onOpen: handleHandShakeClick,
          onOpenMessages: () => navigate("/messages"),
          introductions: (
            <Introductions
              list={introductionList}
              updateIntroStateonHover={updateIntroStateonHover}
              updateIntroPageOnScroll={updateIntroPageOnScroll}
              isLoadIntroList={isLoadIntroList}
              handleCloseIntroList={handleCloseIntroList}
            />
          ),
        }}
      />
    ) : null,
    authButtonsProps: {
      handleAgentOnboardingModal,
    },
    headerSidebarDropdownMenuProps: {
      user,
      userDetails,
      userPlan,
      showAgentMenuNotificationIcon,
      navigate,
      BasicPlanModalShow,
      ContactModalShow,
      handleLogOut,
    }
  })

  return (
    <BaseHeader
      {...allProps}
      headerContent={headerContent}
    />
  );
});

export default HeaderSidebarConsumer;
